// $(window).scroll(function() {
//         var elementOffset = $('#buy_now_btn').offset().top;
//         var windowScrollTop = $(window).scrollTop();
//         if (windowScrollTop >= elementOffset) {
//                 $("#sticky_buy_btn").removeClass("slideOut");
//                 $("#sticky_buy_btn").addClass("slideIn");
//         } else {
//                 $("#sticky_buy_btn").removeClass("slideIn");
//                 $("#sticky_buy_btn").addClass("slideOut");
//         }
// });
// $(window).scroll(function() {
//         // Calculate the distance from the bottom of the page
//         var distanceFromBottom = $(document).height() - $(window).scrollTop() - $(window).height();
//         if (distanceFromBottom <= 200) {
//                 $("#sticky_buy_btn").css("opacity","0");
//         } else {
//             $("#sticky_buy_btn").css("opacity","1");
//         }
// });

$("#comparison_table_see_more_btn").click(function(){
    if ($("#comparison_table_see_more_btn").hasClass("table_hide")) {
        $("#comparison_table_see_more_btn").toggleClass("table_hide");
        $("#comparison_table").animate({height: '850px'});
        $("#show_more_arrow").addClass('rotate');
        $("#show_more_show_text").hide();
        $("#show_more_hide_text").show();
    } else {
        $("#comparison_table_see_more_btn").toggleClass("table_hide");
        $("#comparison_table").animate({height: '250px'});
        $("#show_more_arrow").removeClass('rotate');
        $("#show_more_show_text").show();
        $("#show_more_hide_text").hide();
    }
}); 

$("#buy_now_btn").click(function(){
    $('#buy_now_text').hide();
    $('#subscribe_notice').fadeOut();
    $('#select_options_text').fadeIn();
    
    $('#buy_form').slideDown();
}); 
$("#sticky_buy_btn").click(function(){
    $('#buy_now_text').hide();
    $('#subscribe_notice').fadeOut();
    $('#select_options_text').fadeIn();
    
    $('#buy_form').slideDown();
}); 

        $('.container_collapsible_toggle_show').click(function() {
			$('.container_collapsible_toggle_show').hide();
			$('.container_collapsible_toggle_hide').show();
			var fullHeight = $('.container_collapsible_inner').get(0).scrollHeight;
			$('.container_collapsible_inner').animate({
				height: fullHeight
			}, 500);
		});
		$('.container_collapsible_toggle_hide').click(function() {
			$('.container_collapsible_toggle_hide').hide();
			$('.container_collapsible_toggle_show').show();
			$('.container_collapsible_inner').animate({
				height: '100px'
			}, 500);
		});

        $('#video_play_btn').click(function() {
			$('#video_play_btn').hide();
			$('#guarantee_video video').trigger('play');
		});

        $("#floating_cart_button").click(function(){
			if($('#slide_out_cart').hasClass('open')){
				$("#slide_out_cart").animate({
					right: '-400px',
				}, "fast");
				
				$("#slide_out_cart_overlay").animate({
					opacity: '0',
				}, "fast");
				setTimeout(function(){
					$("#slide_out_cart_overlay").hide();
				}, 500);
				
				
				$("#slide_out_cart").removeClass('open');
			} else {
				$("#slide_out_cart").animate({
					right: '0px',
				}, "fast");
				$("#slide_out_cart_overlay").show();
				$("#slide_out_cart_overlay").animate({
					opacity: '0.7',
				}, "fast");
				$("#slide_out_cart").addClass('open');
			}
			
		});
		$("#top_bar_view_cart_btn").click(function(){
			if($('#slide_out_cart').hasClass('open')){
				$("#slide_out_cart").animate({
					right: '-400px',
				}, "fast");
				$("#slide_out_cart_overlay").animate({
					opacity: '0',
				}, "fast");
				setTimeout(function(){
					$("#slide_out_cart_overlay").hide();
				}, 500);
				$("#slide_out_cart").removeClass('open');
			} else {
				$("#slide_out_cart").animate({
					right: '0px',
				}, "fast");
				$("#slide_out_cart_overlay").show();
				$("#slide_out_cart_overlay").animate({
					opacity: '0.7',
				}, "fast");
				$("#slide_out_cart").addClass('open');
			}
			
		});
		
		
		
		
		$("#slide_out_cart_close_btn").click(function(){
			$("#slide_out_cart").animate({
				right: '-400px',
			}, "fast");
			$("#slide_out_cart_overlay").animate({
				opacity: '0',
			}, "fast");
			setTimeout(function(){
				$("#slide_out_cart_overlay").hide();
			}, 500);
			$("#slide_out_cart").removeClass('open');
			
			
		});

        $("#slide_out_cart_continue_shopping_btn").click(function(){
			$("#slide_out_cart").animate({
				right: '-400px',
			}, "fast");
			$("#slide_out_cart_overlay").animate({
				opacity: '0',
			}, "fast");
			setTimeout(function(){
				$("#slide_out_cart_overlay").hide();
			}, 500);
			$("#slide_out_cart").removeClass('open');
			
			
		});
        $("#slide_out_cart_overlay").click(function(){
			$("#slide_out_cart").animate({
				right: '-400px',
			}, "fast");
			$("#slide_out_cart_overlay").animate({
				opacity: '0',
			}, "fast");
			setTimeout(function(){
				$("#slide_out_cart_overlay").hide();
			}, 500);
			$("#slide_out_cart").removeClass('open');
			
			
		});